import gql from 'graphql-tag';

export const audienceListGQL = gql`
  query (
    $instId: String!
    $filtersv2: FilterExpressionInput!
    $sort: String!
    $page: Int!
    $size: Int!
    $search: String
    $listMemberShip: String
  ) {
    audiences(
      inst_id: $instId
      filtersv2: $filtersv2
      sort: $sort
      page: $page
      size: $size
      search: $search
      listMemberShip: $listMemberShip
    ) {
      audienceList: profiles {
        id
        userKeyConsolidated
        firstName
        lastName
        fullName
        parentFullName
        parentEmail
        parentPhone
        relativeInterestLevel
        major
        visitorType
        highSchoolLevelToday
        enrollTermYear
        enrollTerm
        enroll: enrollYear
        lastActive: lastDateActiveWithInstitution
        hasScheduledVisitAllTime
        hasAppliedAllTime
        lastDateActiveWithYouvisit
        city: city
        state: state
        country: country
        gender
        ethnicity
        dateOfBirth: birthDate
        sat
        act
        gpa
        phone
        email
        currentSchool
        postal
        dateRegistered
        levelOfStudy
        locationName
        locationId
        locationType
        personalizationSuggestions: personalization_suggestions
        personalizationPreferences: personalization_preferences
      }
      page
      totalPages
      totalRecords
    }
  }
`;

export const userPrefsByIdGQL = gql`
  query ($instId: String!, $accountId: String!) {
    userPrefs(instId: $instId, accountId: $accountId) {
      name
      value
      category
      id
      createdAt
      updatedAt
      deletedAt
      instId
    }
  }
`;

export const userPrefsCreate = gql`
  mutation (
    $instId: String!
    $accountId: String!
    $name: String!
    $value: String!
    $category: String!
  ) {
    userPrefsCreate(
      instId: $instId
      accountId: $accountId
      name: $name
      value: $value
      category: $category
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;

export const userPrefsUpdate = gql`
  mutation (
    $instId: String!
    $accountId: String!
    $name: String!
    $value: String!
    $category: String!
    $id: String!
  ) {
    userPrefsUpdate(
      instId: $instId
      accountId: $accountId
      name: $name
      value: $value
      category: $category
      id: $id
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;
